var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCustomModalCardIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 4405"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.666667,
    y: 0.666667,
    width: 38.6667,
    height: 38.6667,
    rx: 4.66667,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1092 14.4104H29.8804H10.1092ZM11.9948 30.1141H27.9948C28.702 30.1141 29.3803 29.8332 29.8804 29.3331C30.3805 28.833 30.6615 28.1547 30.6615 27.4475V13.2253C30.6615 12.518 30.3805 11.8397 29.8804 11.3396C29.3803 10.8395 28.702 10.5586 27.9948 10.5586H11.9948C11.2875 10.5586 10.6093 10.8395 10.1092 11.3396C9.60908 11.8397 9.32813 12.518 9.32812 13.2253V27.4475C9.32812 28.1547 9.60908 28.833 10.1092 29.3331C10.6093 29.8332 11.2875 30.1141 11.9948 30.1141Z",
    fill: "#E0F2FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.18 17.966H20.5874M10.1092 14.4104H29.8804M13.18 22.1141H27.1059M11.9948 30.1141H27.9948C28.702 30.1141 29.3803 29.8332 29.8804 29.3331C30.3805 28.833 30.6615 28.1547 30.6615 27.4475V13.2253C30.6615 12.518 30.3805 11.8397 29.8804 11.3396C29.3803 10.8395 28.702 10.5586 27.9948 10.5586H11.9948C11.2875 10.5586 10.6093 10.8395 10.1092 11.3396C9.60908 11.8397 9.32813 12.518 9.32812 13.2253V27.4475C9.32812 28.1547 9.60908 28.833 10.1092 29.3331C10.6093 29.8332 11.2875 30.1141 11.9948 30.1141Z",
    stroke: "#0EA5E9",
    strokeWidth: 1.77778,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.666667,
    y: 0.666667,
    width: 38.6667,
    height: 38.6667,
    rx: 4.66667,
    stroke: "#E5E7EB",
    strokeWidth: 1.33333
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCustomModalCardIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/custom-modal-card-icon.63b38b688be273dabce793f9ff6b06ad.svg";